import React from "react";
import PlataformaGruposPage from "../components/PlataformaGruposPage";
import { lcCreateUnitGroup, lcGetUnitGroupHistory, lcListUnidades, lcListUnitGroups, lcListUsuarios, lcUpdateUnitGroup } from "../services/leasecontrolUsuarios.service";

export default function LeasecontrolGruposPage() {
  return (
    <PlataformaGruposPage
      title="Grupos"
      subtitle="Modulo de LeaseControl"
      listGroups={lcListUnitGroups}
      createGroup={lcCreateUnitGroup}
      updateGroup={lcUpdateUnitGroup}
      getGroupHistory={lcGetUnitGroupHistory}
      listUsers={lcListUsuarios}
      listUnits={lcListUnidades}
      providerColor="#006d75"
    />
  );
}
